module.exports = __webpack_public_path__ + "static/media/butter.7705e3fb.webp";